import { useState, useEffect } from "react";
import {
  Category,
  GeneralService,
  SelectOption,
} from "../AddGeneralService/types";

type CategoryType = "commercial" | "residential" | "internal";

export const useCategoryOptions = (
  type: CategoryType,
  data?: GeneralService
) => {
  const [categoryOptions, setCategoryOptions] = useState<SelectOption[]>([]);

  useEffect(() => {
    if (!data) return;

    let selectedCategories: Category[] = [];

    switch (type) {
      case "commercial":
        selectedCategories = data.commercial || [];
        break;
      case "residential":
        selectedCategories = data.residential || [];
        break;
      case "internal":
        selectedCategories = data.internal || [];
        break;
      default:
        selectedCategories = [];
    }

    const options = selectedCategories.map((cat) => ({
      label: cat.name,
      value: cat.categoryId,
    }));

    setCategoryOptions(options);
  }, [data, type]);

  return categoryOptions;
};
